import { settingsShopsModule } from "@/store/settings/settingsShopsModule";

export const settingsModules = {
    settingsShops: settingsShopsModule,
}